<template>
	<div class="order-detail-page">
		<nio-header-nav
			position="fixed"
			:is-white="true"
			@back="handleBack"
			:height.sync="headerHeight"
		/>

		<nio-pull-refresh
			@refresh="handleRefresh"
			v-model="pullingRefresh"
			:pull-height="pullHeight"
			:has-more="false"
			:loadMoreStyle="{ display: 'none' }"
		>
			<div
				class="main-content"
				v-if="!!orderData && !!car"
				:style="{
					paddingTop: headerHeight + 15 + 'px',
					paddingBottom: insetBottom + 150 + 'px'
				}"
			>
				<div class="section-status-title multi">
					<div class="title">{{ pageTitle }}</div>
					<div class="subtitle" v-if="pageSubtitle">{{ pageSubtitle }}</div>
				</div>

				<order-car-item v-if="!!car" :car="carItemInfo" :order-no="orderNo" />

				<div class="section-contact">
					<div>
						<template v-for="staff in orderData.staffs">
							<div class="contact-line">
								<nio-profile
									size="small"
									:nioIcon="true"
									inline
									:name="staff.staff_name"
									:image="staff.staff_head_image"
									:jobTitle="getStaffJob(staff.staff_type)"
								/>
								<div class="contact-ways">
									<div
										v-if="staff.staff_mobile"
										class="btn-phone"
										@click="makeCall(staff.staff_mobile)"
									>
										<nio-icon name="icon_phone_2xs" :size="16" />
									</div>

									<div v-if="staff.account_id" class="btn-im" @click="openIMchat(staff.im_id)">
										<nio-icon name="icon_im_2xs" :size="16" />
									</div>
								</div>
							</div>
						</template>

						<div v-if="!orderData.staffs || !orderData.staffs.length" class="contact-line">
							<nio-profile
								size="small"
								:nioIcon="true"
								inline
								name="牛小二"
								image="https://cdn-app.nio.com/user/2022/5/23/4092f373-6d51-4d88-ad76-0d24cc1ac93c.jpeg"
								jobTitle="二手车买卖童叟无欺"
							/>
							<div class="contact-ways">
								<div class="btn-phone" @click="makeCall('4009996699')">
									<nio-icon name="icon_phone_2xs" :size="16" />
								</div>

								<div class="btn-im" @click="openIMchat">
									<nio-icon name="icon_im_2xs" :size="16" />
								</div>
							</div>
						</div>
					</div>

					<div class="contact-message">
						{{ pageHelp }}
					</div>
				</div>

				<div class="section-menu">
					<Menu
						:title="holderInfoMenu.title"
						:fields="holderInfoMenu.fields"
						:link="
							[
								CE_FLOW.DELIVERY,
								CE_FLOW.ORDER_CANCEL,
								CE_FLOW.ORDER_EXPIRED,
								CE_FLOW.WAIT_DEPOSIT,
								CE_FLOW.REFUNDING,
								CE_FLOW.REFUND_FINISH
							].indexOf(CEState) < 0
						"
						@link="goToOwnerTask"
					/>

					<Menu
						v-if="orderData.pay_info"
						:title="paymentDetailMenu.title"
						:fields="paymentDetailMenu.fields"
					/>

					<Menu
						v-if="CEState >= CE_FLOW.CHECK_CONFIRMED && hasProtocol"
						title="购车协议"
						:fields="[]"
						:link="true"
						@link="goToProtocol"
					/>

					<Menu
						:title="orderInfoMenu.title"
						:fields="orderInfoMenu.fields"
						:order-no="orderNo"
						@fieldLink="goToSnapshot"
					/>
				</div>

				<div class="float-bottom-area" v-if="CEState === CE_FLOW.WAIT_DEPOSIT">
					<div class="tips-row">
						<nio-icon name="icon_error_medium_m" :size="14" style="height: 16px" />
						<span class="normal">
							{{ waitingPayTime }} 请在倒计时结束前支付定金，锁定你的爱车！
						</span>
					</div>

					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button class="cancel-btn" type="btn_outline_l" @click="goToQuit">
							取消订单
						</nio-button>
						<nio-button @click="payDeposit">
							支付定金 ¥{{ formatCurrency(orderData.pay_info.deposit_amount) }}
						</nio-button>
					</div>
				</div>

				<div class="float-bottom-area" v-if="CEState === CE_FLOW.DEPOSIT_PAID">
					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button type="btn_outline_l" @click="showQuitDialog = true">申请退款</nio-button>
					</div>
				</div>
				<div class="float-bottom-area" v-if="CEState === CE_FLOW.AGREEMENT_SIGNED">
					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button
							v-if="orderData.pay_info.final_amount && checkFinalStatus()"
							@click="payTail"
						>
							支付尾款
						</nio-button>
					</div>
				</div>

				<div class="float-bottom-area" v-if="CEState === CE_FLOW.ORDER_CANCEL">
					<div class="tips-row" v-if="orderData.cancel_reason_code === 7">
						爱车已被其他人抢走，去商城看看吧~
					</div>

					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button class="delete-btn" type="btn_outline_l" @click="showDeleteDialog = true">
							删除订单
						</nio-button>
						<nio-button @click="goToMall" v-if="orderData.cancel_reason_code === 7">
							去商城看看
						</nio-button>
					</div>
				</div>

				<div class="float-bottom-area" v-if="CEState === CE_FLOW.ORDER_EXPIRED">
					<div class="tips-row">
						订单支付超时，系统自动取消，请重新下单！
					</div>

					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button class="delete-btn" type="btn_outline_l" @click="showDeleteDialog = true">
							删除订单
						</nio-button>
						<nio-button @click="retryOrder">重新下单</nio-button>
					</div>
				</div>

				<div
					class="float-bottom-area"
					v-if="CEState === CE_FLOW.DELIVERY || CEState === CE_FLOW.REFUND_FINISH"
				>
					<div class="options-row" :style="{ paddingBottom: (insetBottom || 15) + 'px' }">
						<nio-button type="btn_outline_l" @click="showDeleteDialog = true">删除订单</nio-button>
					</div>
				</div>
			</div>
		</nio-pull-refresh>

		<nio-dialog
			v-model="showQuitDialog"
			description="申请退款车辆优惠将失效，请您确认是否取消订单"
			:confirm="{ name: '确认', action: goToRefund }"
			:cancel="{ name: '取消', action: closeQuitDialog }"
		/>

		<nio-dialog
			v-model="showDeleteDialog"
			description="确认删除订单吗？删除之后订单列表将不再显示"
			:confirm="{ name: '确认', action: deleteOrder }"
			:cancel="{ name: '取消', action: closeDeleteDialog }"
		/>
	</div>
</template>

<script>
import nativeHybrid from '@/util/nativeHybrid'
import { formatMinutes, getSafeInsetBottom, getSafeInsetTop, px2vw } from '@/util/unit-transfer'
import {
	getCancelReasons,
	getOrderDetail,
	getOrderTradeNo,
	queryOrderProtocols,
	queryTradeStatus,
	queryVehicleDetail,
	checkPayStatus,
	deleteOrder
} from '@/model'
import Menu from '@/views1/OrderDetailPage/Menu'
import OrderCarItem from '@/components/OrderCarItem'
import { carDetailToCarItem } from '@/util/data-transfer'
import {
	CE_FLOW,
	CE_FLOW_HELP,
	CE_FLOW_SUBTITLE,
	CE_FLOW_TITLE,
	getCEStateByOrder
} from '@/views1/OrderDetailPage/flowData'
import axios from 'axios'
import dayjs from 'dayjs'
import util from '@/util/util'
import { supreme } from '@/supreme-core'
import link from '@/util/link'
import hybrid from '@/util/nativeHybrid'
import qs from 'qs'

export default {
	name: 'index',
	components: { OrderCarItem, Menu },
	data() {
		return {
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			car: null,
			CE_FLOW: CE_FLOW,

			orderData: null,
			orderNo: supreme.getQueryString('order_no'),
			skuCode: '',
			waitingPayTime: '',
			formatCurrency: util.formatCurrency,
			showClipboard: false,
			isPaying: false,
			depositTimer: null,
			showQuitDialog: false,
			hasProtocol: false,

			pullingRefresh: false,
			pullHeight: px2vw(getSafeInsetTop()),
			showDeleteDialog: false
		}
	},
	computed: {
		carItemInfo() {
			if (!this.car) {
				return null
			}
			return carDetailToCarItem(this.car)
		},
		nickname() {
			return this.car.basic.business_type === 1 ? '牛小二' : this.car.basic.nickname
		},
		avatar() {
			return this.car.basic.business_type === 1
				? 'https://cdn-app.nio.com/user/2022/5/23/4092f373-6d51-4d88-ad76-0d24cc1ac93c.jpeg'
				: this.car.basic.head_image
		},
		jobTitle() {
			return this.car.basic.business_type === 1 ? '二手车买卖童叟无欺' : '原车主（卖家）'
		},

		holderInfoMenu() {
			return {
				title: '车主信息',
				fields: [{ label: '姓名', value: this.orderData.owner.owner_name }]
			}
		},

		paymentDetailMenu() {
			let fields = []
			if (!this.orderData.pay_info) {
				return null
			}

			if (this.CEState <= CE_FLOW.WAIT_DEPOSIT) {
				fields = [
					{
						label: '定金',
						value: this.orderData.pay_info.deposit_amount,
						amount: true
					},
					{
						label: '应付金额',
						value: this.orderData.pay_info.deposit_amount,
						amount: true,
						bold: true
					}
				]
			} else if (this.CEState <= CE_FLOW.CHECK_CONFIRMED) {
				fields = [
					{
						label: '车辆价格',
						value: this.orderData.pay_info.commodity_price,
						amount: true
					},
					{
						label: '已付定金',
						value: this.orderData.pay_info.deposit_amount_paid,
						amount: true
					},
					{
						label: '应付尾款余额',
						value: this.orderData.pay_info.final_amount,
						amount: true,
						bold: true
					}
				]
			} else if (this.CEState <= CE_FLOW.AGREEMENT_SIGNED) {
				fields = [
					{
						label: '车辆价格',
						value: this.orderData.pay_info.commodity_price,
						amount: true
					},
					...(this.orderData.pay_info.promotion_amount
						? [
								{
									label: '商业折扣',
									value: this.orderData.pay_info.promotion_amount,
									amount: true,
									discount: true
								}
						  ]
						: []),

					...(this.checkShowLoanAmount()
						? [
								{
									label: '贷款/融资金额',
									value: this.orderData.pay_info.loan_amount,
									amount: true,
									discount: true
								}
						  ]
						: []),

					{
						label: '已付定金',
						value: this.orderData.pay_info.deposit_amount_paid,
						amount: true,
						discount: true
					},

					...(this.orderData.pay_info.final_amount_paid
						? [
								{
									label: '已付尾款',
									value: this.orderData.pay_info.final_amount_paid,
									amount: true,
									discount: true
								}
						  ]
						: []),
					{
						label: '应付尾款余额',
						value: this.orderData.pay_info.final_amount,
						amount: true,
						bold: true
					}
				]
			} else if (this.CEState <= CE_FLOW.DELIVERY) {
				fields = [
					{
						label: '车辆价格',
						value: this.orderData.pay_info.commodity_price,
						amount: true
					},
					...(this.orderData.pay_info.promotion_amount
						? [
								{
									label: '商业折扣',
									value: this.orderData.pay_info.promotion_amount,
									amount: true,
									discount: true
								}
						  ]
						: []),

					...(this.orderData.pay_info.loan_amount
						? [
								{
									label: '贷款/融资金额',
									value: this.orderData.pay_info.loan_amount,
									amount: true,
									discount: true
								}
						  ]
						: []),
					{
						label: '已付定金',
						value: this.orderData.pay_info.deposit_amount_paid,
						amount: true,
						discount: true
					},

					{
						label: '已付尾款',
						value: this.orderData.pay_info.final_amount_paid,
						amount: true,
						discount: true
					},
					{
						label: '购车总价',
						value: this.orderData.pay_info.order_price,
						amount: true,
						bold: true
					}
				]
			} else {
				fields = [
					{
						label: '车辆价格',
						value: this.orderData.pay_info.commodity_price,
						amount: true
					},
					{
						label: '已付定金',
						value: this.orderData.pay_info.deposit_amount_paid,
						amount: true,
						discount: true
					},
					{
						label: '已付尾款',
						value: this.orderData.pay_info.final_amount_paid,
						amount: true,
						discount: true
					},
					{
						label: '实退金额',
						value: this.orderData.pay_info.pay_back_amount_refund,
						amount: true,
						bold: true
					}
				]
			}

			return {
				title: '付款明细',
				fields
			}
		},
		orderInfoMenu() {
			return {
				title: '订单信息',
				fields: [
					{ label: '订单编号', value: this.orderData.order_no, copy: true },
					{
						label: '下单时间',
						value: util.formatDate(this.orderData.create_time * 1000, 'YYYY/MM/DD HH:mm')
					},

					...(this.car.basic.business_type !== 3
						? [{ label: '交易快照', value: '查看交易时详情', link: true }]
						: []),
					{ label: '上牌城市', value: this.orderData.registration_city_name }
				]
			}
		},
		CEState() {
			if (!this.orderData) {
				return undefined
			}
			// 从orderData判断出车辆的状态
			return getCEStateByOrder(this.orderData)
		},
		pageTitle() {
			return CE_FLOW_TITLE[this.CEState]
		},

		pageSubtitle() {
			if (this.CEState === CE_FLOW.TRANSFORM_FINISHED_IN_BOOKING) {
				return CE_FLOW_SUBTITLE[this.CEState](
					dayjs(this.orderData.delivery_car_time * 1000).format('YY年MM月DD日,HH时')
				)
			}
			return CE_FLOW_SUBTITLE[this.CEState]
		},

		pageHelp() {
			return CE_FLOW_HELP[this.CEState]
		},
		countDownStart() {
			let seconds =
				this.orderData.create_time +
				this.orderData.restriction_pay_time * 60 -
				Math.ceil(Date.now() / 1000)
			if (seconds < 0) {
				seconds = 0
			}

			return seconds
		}
	},
	created() {
		this.$showLoading('加载中')
		setTimeout(() => {
			this.fetchDetail()
				.then(orderData => {
					this.orderData = orderData
				})
				.finally(() => {
					this.$hideLoading()
				})
		}, 500)

		getCancelReasons.get({})

		document.addEventListener('visibilitychange', () => {
			let hiddenProperty =
				'hidden' in document
					? 'hidden'
					: 'webkitHidden' in document
					? 'webkitHidden'
					: 'mozHidden' in document
					? 'mozHidden'
					: null

			const hidden = document[hiddenProperty]
			if (!hidden) {
				this.handleRefresh()
			}
		})
	},

	methods: {
		getStaffJob(type) {
			const jobs = [
				'未知',
				'二手车专家',
				'交付管家',
				'车源地仓储专员',
				'交付地仓储专员',
				'pdi专员',
				'延展专员',
				'交付专家'
			]
			return jobs[type]
		},
		async onAppear() {
			let checkPayResult = false

			// 客户端支付台返回
			if (this.isPaying) {
				checkPayResult = true
			}

			// 微信小程序支付跳转
			if (nativeHybrid.isWeapp() && location.href.indexOf('pay_finish') > 0) {
				checkPayResult = true
			}

			if (!checkPayResult) {
				return
			}
			this.orderData = await this.fetchDetail()
			if (!this.isPaying) {
				return
			}

			this.isPaying = false
			queryTradeStatus
				.get({
					order_no: this.orderNo,
					trade_no:
						this.CEState <= CE_FLOW.DEPOSIT_PAID
							? this.orderData.deposit_trade_no
							: this.orderData.final_pay_trade_no
				})
				.then(res => {
					const { data } = res
					if (!data || data.result_code !== 'success') {
						let error = {}
						error.message = data.debug_msg || data.display_msg || '网络错误'
						throw error
					}
					const { code, trade_no_type } = data.data

					this.isPaying = false
					if (trade_no_type === 2 && (code === 2 || code === 3)) {
						link.goToRoute('/pay-result', {
							success: 'true',
							order_no: this.orderNo
						})
					} else if (trade_no_type === 1 && code === 2) {
						link.goToRoute('/pay-result', {
							success: 'true',
							order_no: this.orderNo
						})
					} else {
						// link.goToRoute('/pay-result', {
						// 	success: 'false',
						// 	order_no: this.orderNo
						// })
						this.$toast('支付失败')
					}
				})
		},
		goToOwnerTask() {
			link.goToRoute('/taskCarOwner', {
				order_no: this.orderNo
			})
		},
		handleBack() {
			nativeHybrid.closeSyn()
		},

		handleRefresh() {
			this.fetchDetail()
				.then(orderData => {
					this.orderData = orderData
				})
				.finally(() => {
					this.pullingRefresh = false
				})
		},
		goToQuit() {
			link.goToRoute('/quit-reason', {
				order_no: this.orderNo
			})
		},
		goToProtocol() {
			link.goToRoute('/orderProtocolList', {
				order_no: this.orderNo
			})
		},
		closeQuitDialog() {
			this.showQuitDialog = false
		},
		goToRefund() {
			this.showQuitDialog = false
			link.goToRoute('/refund-reason', {
				order_no: this.orderNo
			})
		},
		goToMall() {
			link.goToRoute('/carhome', {}, true)

			// setTimeout(() => {
			// 	nativeHybrid.closeSyn()
			// }, 500)
		},

		checkFinalStatus() {
			if (this.orderData.finance.loan_status + '' === '0') {
				// 待定状态
				return false
			}

			if (this.orderData.finance.loan_status + '' === '1' || !this.orderData.pay_info.loan_amount) {
				// 不需要贷款
				return true
			}

			// 需要贷款的情况

			if (this.orderData.finance.loan_channel + '' === '1') {
				// 蔚来金融渠道
				return true
			}

			// 银行贷款渠道需要判断进度
			if (
				['receiving_loan_advice', 'receiving_approved_loan_advice', 'loan_success'].indexOf(
					this.orderData.finance.financial_status
				) >= 0
			) {
				return true
			}

			return false
		},

		checkShowLoanAmount() {
			if (!this.orderData.pay_info || !this.orderData.pay_info.loan_amount) {
				return false
			}
			if (this.orderData.finance.loan_channel + '' === '1') {
				return true
			}

			if (this.orderData.finance.loan_channel + '' === '2') {
				return this.checkFinalStatus()
			}

			return false
		},

		goToSnapshot() {
			link.goToRoute('/detail', {
				sku_code: this.car.basic.commodity_code,
				snapshot_no: this.orderData.snapshot_no,
				snapshot: 'true'
			})
		},
		makeCall(phone) {
			hybrid.makeCall(phone)
		},
		openIMchat(accountId) {
			if (!accountId) {
				accountId = util.getBaseEnvInfo().secondHandChatPersonId
			}
			hybrid.openURL(`nio://conversation?id=${encodeURIComponent(accountId)}&type=private`)
		},
		async retryOrder() {
			const curOrder = await this.fetchDetail()
			if (getCEStateByOrder(curOrder) === CE_FLOW.ORDER_EXPIRED) {
				link.goToRoute(
					'/orderCreator',
					{
						sku_code: this.skuCode,
						old_order_no: this.orderNo
					},
					true
				)

				// setTimeout(() => {
				// 	nativeHybrid.closeSyn()
				// }, 500)
			} else {
				this.$toast('无法重新下单')
			}
		},
		async fetchDetail() {
			try {
				this.fetchProtocolState()

				const { data } = await getOrderDetail.get({}, `/${this.orderNo}/detail`)

				const orderData = data.data
				this.skuCode = data.data.commodity.commodity_code
				const carResult = await queryVehicleDetail.get({}, '/' + this.skuCode)

				if (!carResult.data || carResult.data.result_code !== 'success') {
					throw new Error()
				}

				this.car = carResult.data.data

				return orderData
			} catch (e) {
				if (util.isInWebview()) {
					this.$router.push({
						path: '/error',
						query: { message: '网络请求失败' }
					})
				}
			}
		},

		async fetchProtocolState() {
			const res = await queryOrderProtocols.get({
				order_no: this.orderNo
			})

			if (
				res.data &&
				res.data.data &&
				res.data.data.length &&
				res.data.data.some(one => !!one.protocol_no)
			) {
				this.hasProtocol = true
			} else {
				this.hasProtocol = false
			}
		},
		async payDeposit() {
			// 校验订金是否被支付
			const { data: checkData } = await checkPayStatus.get({}, `/${this.skuCode}`)
			if (!checkData || checkData.result_code !== 'success') {
				let error = {}
				error.message = checkData.debug_msg || checkData.display_msg || '网络错误'
				throw error
			}

			if (checkData.data.is_payed === true) {
				this.$toast('该车辆已被抢定了，可以看看其他车辆哦')
				this.$hideLoading()
				return
			}

			const res = await getOrderTradeNo.get({
				order_no: this.orderNo,
				trade_type: 1
			})
			const { data } = res
			if (!data || data.result_code !== 'success') {
				let error = {}
				error.message = data.debug_msg || data.display_msg || '网络错误'
				throw error
			}
			const depositTradeNo = data.data.pay_order_no
			const merchantNo = data.data.merchant_no
			this.isPaying = true

			if (nativeHybrid.isWeapp()) {
				const subpath = `/order-detail?order_no=${this.orderNo}`
				const params = {
					amount: this.orderData.pay_info.deposit_amount,
					payOrderNo: depositTradeNo,
					merchantNo,
					body: encodeURIComponent('官方二手车'),
					successCallbackUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(
						subpath + '&pay_result=true'
					)}`,
					failCallbackUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(
						subpath + '&pay_result=true'
					)}`,
					originUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(subpath)}`
				}

				let url = '/pages/pay2/index?' + qs.stringify(params)
				window.wx.miniProgram.redirectTo({
					url: url
				})
			} else {
				const url = `nio://pay/paylist?merchant_no=${merchantNo}&pay_order_no=${depositTradeNo}`

				nativeHybrid.openURL(url)
			}
		},

		async payTail() {
			const res = await getOrderTradeNo.get({
				order_no: this.orderNo,
				trade_type: 2
			})
			const { data } = res
			if (!data || data.result_code !== 'success') {
				let error = {}
				error.message = data.debug_msg || data.display_msg || '网络错误'
				throw error
			}
			const depositTradeNo = data.data.pay_order_no
			const merchantNo = data.data.merchant_no
			this.isPaying = true

			const url = `nio://pay/paylist?merchant_no=${merchantNo}&pay_order_no=${depositTradeNo}`

			nativeHybrid.openURL(url)
		},

		startTick() {
			// 定金倒计时
			const origin = this.countDownStart
			if (origin > 0) {
				const finishDate = Date.now() / 1000 + origin

				if (this.depositTimer) {
					clearInterval(this.depositTimer)
				}

				let timer = setInterval(() => {
					let restSeconds = Math.ceil(finishDate - Date.now() / 1000)

					if (restSeconds <= 0) {
						restSeconds = 0
						clearInterval(timer)
					}

					this.waitingPayTime = formatMinutes(restSeconds)
				}, 200)

				this.depositTimer = timer
			} else {
				this.waitingPayTime = formatMinutes(0)
			}
		},
		async deleteOrder() {
			const params = {
				order_no: this.orderNo
			}

			deleteOrder
				.post(params)
				.then(res => {
					this.showDeleteDialog = false
					hybrid.closeSyn()
				})
				.catch(err => {
					console.log(err)
					this.$toast('删除失败')
				})
		},

		closeDeleteDialog() {
			this.showDeleteDialog = false
		}
	},
	watch: {
		orderData() {
			if (this.CEState <= CE_FLOW.WAIT_DEPOSIT) {
				this.startTick()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.order-detail-page {
	.main-content {
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;

		.section-status-title {
			&.multi {
				margin-bottom: 30px;
			}

			.title {
				@include headline_1(1.2, 400, false);
				color: $text_primary;
			}

			.subtitle {
				margin-top: 10px;
				@include subtitle_3(1.5, 400, false);
				color: $text_primary;
			}
		}

		.section-contact {
			margin-top: 60px;

			.contact-line {
				display: flex;
				justify-content: space-between;

				&:not(:last-child) {
					margin-bottom: 40px;
				}

				::v-deep {
					.nio-profile__job-title {
						margin-top: 2px;
					}
				}
			}

			.contact-message {
				margin-top: 20px;
				@include body_2(1.5, 400, false);
			}

			.contact-ways {
				display: flex;

				> * {
					width: 40px;
					height: 40px;
					border: 1px solid #e9ebf1;
					border-radius: 40px;

					display: flex;
					align-items: center;
					justify-content: center;

					&:first-child {
						margin-right: 15px;
					}
				}
			}
		}

		.section-options {
			height: 108px;
		}
	}

	.float-bottom-area {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: #ffffff;

		.tips-row {
			padding: 11px 20px;
			background: #f2fcfc;
			color: $text_link;
			font-size: 14px;
			line-height: 20px;

			.normal {
				@include body_3(1.5, 400, false);
				margin-left: 10px;
			}
		}

		.options-row {
			padding: 15px 20px;
			display: flex;

			> * {
				flex: 1;
			}

			.cancel-btn {
				border: 1px solid #ced0d6;
			}
			.delete-btn {
				margin-right: 15px;
			}
		}
	}
}
</style>
